export const getValueLabel = (value: string | null) => value || '-';
